import { render } from "./InstructorDetails.vue?vue&type=template&id=8848c518"
import script from "./InstructorDetails.vue?vue&type=script&lang=js"
export * from "./InstructorDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__